<form [formGroup]="settingsForm">
  <!-- Time format -->
  <mat-card class="setting-card">
    <mat-card-title>
      {{ 'SETTINGS.TIME_FORMAT.TITLE' | translate }}
    </mat-card-title>
    <mat-card-content class="setting-content">
      <div class="setting-description">
        {{ 'SETTINGS.TIME_FORMAT.DESCRIPTION' | translate }}
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="timeFormat">
          @for (timeFormat of timeFormats; track timeFormat) {
            <mat-option [value]="timeFormat">{{ timeFormat }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <!-- Language -->
  <mat-card class="setting-card">
    <mat-card-title>
      {{ 'SETTINGS.LANGUAGE.TITLE' | translate }}
    </mat-card-title>
    <mat-card-content class="setting-content">
      <div class="setting-description">
        {{ 'SETTINGS.LANGUAGE.DESCRIPTION' | translate }}
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="language">
          @for (language of languages; track language) {
            <mat-option [value]="language">{{ language }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <!-- Color scheme -->
  @if (userCanModifyViewMode) {
    <mat-card class="setting-card">
      <mat-card-title>
        {{ 'SETTINGS.COLOR_SCHEME.TITLE' | translate }}
      </mat-card-title>
      <mat-card-content class="setting-content">
        <div class="setting-description">
          {{ 'SETTINGS.COLOR_SCHEME.DESCRIPTION' | translate }}
        </div>
        <mat-form-field appearance="outline">
          <mat-select formControlName="colorScheme">
            <mat-option [value]="ColorScheme.LIGHT">{{ ColorScheme.LIGHT }}</mat-option>
            <mat-option [value]="ColorScheme.DARK">{{ ColorScheme.DARK }}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
  }
</form>
@if (legalHelpLinks.length) {
  <mat-card class="setting-card settings-legal-card">
    <mat-card-title>
      {{ 'SETTINGS.LEGAL.TITLE' | translate }}
    </mat-card-title>
    <mat-card-content class="legal-card-content">
      @for (link of legalHelpLinks; track $index) {
        <a [href]="link.url" target="_blank" rel="noopener noreferrer">{{
          link.labelTranslationKey | translate
        }}</a>
      }
    </mat-card-content>
  </mat-card>
}
@if (userCanChangePassword) {
  <form [formGroup]="passwordChangeForm" (submit)="savePassword()">
    <!-- Color scheme -->
    <mat-card class="setting-card">
      <mat-card-title>
        {{ 'SETTINGS.PASSWORD_CHANGE.TITLE' | translate }}
      </mat-card-title>
      <mat-card-content class="password-setting-content">
        <div class="setting-description">
          {{ 'SETTINGS.PASSWORD_CHANGE.DESCRIPTION' | translate }}
        </div>
        <div class="password-change-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'GENERIC.PASSWORD' | translate }}</mat-label>
            <input matInput type="password" formControlName="password" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'GENERIC.PASSWORD_AGAIN' | translate }}</mat-label>
            <input matInput type="password" formControlName="passwordAgain" />
          </mat-form-field>
          @if (passwordChangeForm.get('password').hasError('tooShort')) {
            <p class="error">
              {{ 'GENERIC.PASSWORD_TOO_SHORT' | translate }}
            </p>
          }
          @if (passwordChangeForm.get('password').hasError('upperCaseMissing')) {
            <p class="error">
              {{ 'GENERIC.PASSWORD_MISSING_UPPERCASE' | translate }}
            </p>
          }
          @if (passwordChangeForm.get('password').hasError('digitMissing')) {
            <p class="error">
              {{ 'GENERIC.PASSWORD_MISSING_DIGIT' | translate }}
            </p>
          }
          @if (passwordChangeForm.get('password').hasError('invalidCharacter')) {
            <p class="error">
              {{ 'GENERIC.INVALID_CHARACTER' | translate }}
            </p>
          }
          @if (passwordChangeForm.hasError('mismatch')) {
            <p class="error">
              {{ 'GENERIC.PASSWORD_MISMATCH' | translate }}
            </p>
          }
          <button
            type="submit"
            mat-flat-button
            color="primary"
            [disabled]="disablePasswordChangeButton || passwordChangeForm.invalid"
          >
            {{ 'SETTINGS.PASSWORD_CHANGE.BUTTON' | translate }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
}
